module.exports = __webpack_public_path__ + "media/images/rema-5-442a598a827d9448634f0d9685d00060.jpg";